import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

const languageRangeLabel = (page: number, pageSize: number, length: number) => {
  if (length == 0 || pageSize == 0) { return `0 / ${length}`; }
  
  length = Math.max(length, 0);

  const startIndex = page * pageSize;

  // If the start index exceeds the list length, do not try and fix the end index to the end.
  const endIndex = startIndex < length ?
      Math.min(startIndex + pageSize, length) :
      startIndex + pageSize;

  return `${startIndex + 1} - ${endIndex} / ${length}`;
}


export function getPaginatorIntl() {
  const paginatorIntl = new MatPaginatorIntl();
  /*
  paginatorIntl.nextPageLabel = this.translate.instant("paginator.next_page");
  paginatorIntl.previousPageLabel = this.translate.instant("paginator.previous_page");
  */
  //paginatorIntl.itemsPerPageLabel = localStorage.getItem("language")=="es"?"Items por página":"Items per page";
  paginatorIntl.getRangeLabel = languageRangeLabel;

  return paginatorIntl;
}